/**
 * Simple Modal 0.1
 *
 * This modal was created for simple purposes, and it's functional as it is
 * Created using ES5 for compatibility, no need of jQuery
 *
 * @author Bruno "Funnie" de Oliveira
 * @email brunodeoliveira@gmail.com
 *
 */

/**
 * Main SimpleModal constructor
 *
 * @param {*} content The content that will be inserted i1to the modal
 * @param {*} modalContainer Root element of the modal
 */
function SimpleModal(options) {
    var options = options ? options : {};
    var defaults = {
        content: '',
        modalContainer: '#simple-modal',
        modalClass: 'simple-modal',
        classes: [],
        acceptButtonClass: '.sm-button-accept',
        cancelButtonClass: '.sm-button-cancel',
        acceptButtonAction: function() {},
        cancelButtonAction: this.hide,
    }
    this.opts = Object.assign(defaults, options);

    // Initialize modal
    if (!this.isCreated()) {
        this.create();
    }

    return this;
};

/**
 * Initialize basic functionality
 */
SimpleModal.prototype.init = function ()
{
    var that = this;
    var modal = document.querySelector(this.opts.modalContainer);

    // User custom events
    this.on(modal, 'click', this.opts.acceptButtonClass, this.opts.acceptButtonAction);
    this.on(modal, 'click', this.opts.cancelButtonClass, this.opts.cancelButtonAction);

    // Core events
    // Hide the modal when pressing ESC key
    this.on(document, 'keydown', 'body', function(e) {
        if (e.keyCode === 27 && this.isCreated() && this.isOpen()) {
            that.hide();
        }
    });

};

/**
 * Create element and append to the document body
 */
SimpleModal.prototype.create = function ()
{
    var el = document.createElement('div');
    el.setAttribute('id', this.opts.modalContainer.replace(/[#.]+/g, ''))
    el.classList.add(this.opts.modalClass);
    this.opts.classes.forEach(function(cl, i){
        el.classList.add(cl);
    });

    document.body.appendChild(el);

    this.init();
};

/**
 * Check if modal container is created
 */
SimpleModal.prototype.isCreated = function ()
{
    if (document.querySelector(this.opts.modalContainer)) {
        return true;
    }
    return false;
};

/**
 * Show modal overwriting content or not
 * @param {string} content Content string
 */
SimpleModal.prototype.show = function (content)
{
    var content = (content) ? content : this.content;
    document.querySelector(this.opts.modalContainer).classList.add('show');
    document.querySelector(this.opts.modalContainer).innerHTML = content;
    this.toggleScrollbars();
};

/**
 * Un-optimized toggle scrollbars function (need refactor)
 */
SimpleModal.prototype.toggleScrollbars = function ()
{
    var body = document.body;
    var modal = document.querySelector(this.opts.modalContainer);
    var modalChildHeight = modal.children[0].offsetHeight;

    if (this.isOpen()) {
        if (body.style.overflowY == 'hidden') {
            body.style.overflowY = 'scroll';
            modal.style.overflowY = 'hidden';
        } else {
            if (modalChildHeight > window.innerHeight) {;
                body.style.overflowY = 'hidden';
                modal.style.overflowY = 'scroll';
            }  else {
                body.style.overflowY = 'hidden';
                body.style.overflowY = 'hidden';
            }
        }
    } else {
        body.style.overflowY = 'scroll';
        modal.style.overflowY = 'hidden';
    }
}

/**
 * Hide modal
 */
SimpleModal.prototype.hide = function ()
{
    document.querySelector(this.opts.modalContainer).classList.remove('show');
    this.toggleScrollbars();
};

/**
 * Hide modal and clear content
 */
SimpleModal.prototype.destroy = function ()
{
    document.querySelector(this.opts.modalContainer).classList.remove('show');
    document.querySelector(this.opts.modalContainer).innerHTML = '';
    this.content = null;
};

/**
 * Get the modal element
 */
SimpleModal.prototype.getModal = function ()
{
    return document.querySelector(this.opts.modalContainer);
};

/**
 * Toggle modal
 */
SimpleModal.prototype.toggle = function ()
{
    document.querySelector(this.opts.modalContainer).classList.toggle('show');
    this.toggleScrollbars();
};

/**
 * Is modal open check
 */
SimpleModal.prototype.isOpen = function ()
{
    if (document.querySelector(this.opts.modalContainer).classList.contains('show')){
        return true;
    }
    return false;
};

/**
 * Append event to element
 *
 * @param {dom} el Element
 * @param {string} evt Event name
 * @param {string} sel Element selector identifier
 * @param {function} handler Callback function
 */
SimpleModal.prototype.on = function(el, evt, sel, handler) {
    var that = this;
    el.addEventListener(evt, function(event) {
        var t = event.target;
        while (t && t !== this) {
            if (t.matches(sel)) {
                handler.bind(that).call(t, event);
            }
            t = t.parentNode;
        }
    });
};
